export const WATER_PROOFING_PACKAGE_DISCOUNT = {
    SMALL: 559.00,
    MEDIUM: 386.50,
    LARGE: 622.00,
    XLARGE: 636.50,
};